'use strict';

require('../less/common.less');

import $ from 'jquery';

// This allows angular to find jQuery on the window
window.$ = $;
window.jQuery = $;

import angular from 'angular';
import uiRouter from '@uirouter/angularjs';

import videogular from 'videogular';
import videogularControlls from 'videogular-controls';
import videogularBuffering from 'videogular-buffering';
import videogularOverlayPlay from 'videogular-overlay-play';
import videogularThemesDefault from 'videogular-themes-default';

import angularUtilsPagination from 'angular-utils-pagination';

import infiniteScroll from 'ng-infinite-scroll';

import {core} from 'site_core';

// Our Modules
import appRoutes from './app.routes';
import appRun from './app.run';


'ngInject';
var app = angular.module('site', [
  angularUtilsPagination,
  uiRouter,
  core.components,
  core.features,
  core.factories,
  core.filters,
  videogular,
  videogularControlls,
  videogularBuffering,
  videogularOverlayPlay,
  infiniteScroll
]);

app.config(appRoutes);
app.run(appRun);

app.constant('BASE_URLS', {API: API_URL, CONTENT: CONTENT_URL});

app.constant('siteConst', {
	id: 3,
  urlShort: 'SpankingOnline.com',
  urlLong: 'http://www.SpankingOnline.com',
  urlMed: 'www.SpankingOnline.com',
  name: 'Spanking Online',
  tagline: 'SON Tagline GOES HERE...',
  footerTagline: '<a href="/join">join now to view our exclusive spankings videos!</a><p>You can buy more Clips at <a href="http://clips4sale.com/studio/44797/" target="_blank">Clip4sale</a> or on <a href="http://www.spankinglibrary.com/store/161" target="_blank">Spanking Library</a>. Always HARD, always on the BARE! Panties pulled down, spread for punishment with HAND, HAIRBRUSH, BELT, STRAP, CANE, and PADDLE.</p>',
  logoLarge: 'images/logo.png',
  logoSmall: 'images/logo.png',
  twoTwoFiveSevenAddress: '5400 W. 64th Ave Arvada, CO 80007',
  webmasterEmail: 'webmaster@xerotics.com',
  metaDescription: 'SpankingOnline Hard bare bottom schoolgirl spanking caning and strapping videos and photos, high definition spanking movie downloads',
  tour: {
    updates: 12,
    comingSoon: 3,
    models: 24
  },
  advert: {
    tour: [
      'UK and USA Bare Bottom Spankings',
      'Exclusive Spanking Content',
      'Full Updates Twice a Week',
      'Unlimited Streaming and Downloads',
      'Mobile and Tablet Ready',
      'Classic British Spanking',
      'Domestic Discipline Punishments',
      'Strapping, Caning, Slipper Videos',
      'Plus So Much More!'
    ],
    trailer: [
      'UK and USA Bare Bottom Spankings',
      'Exclusive Spanking Content',
      'Full Updates Twice a Week',
      'Unlimited Streaming and Downloads',
      'Mobile and Tablet Ready',
      'Classic British Spanking',
      'Domestic Discipline Punishments',
      'Strapping, Caning, Slipper Videos',
      'Plus So Much More!'
    ]
  }
});



// WEBPACK FOOTER //
// ./src/app/app.js